'use client'
import {
  convertCurrencyToPoints,
  convertPointsToCurrency
} from "./chunk-WETELLTX.mjs";
import {
  useRedeem
} from "./chunk-7OO2W25G.mjs";
import {
  usePayment
} from "./chunk-QH2UTQBS.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/booking/redeem/RedeemForm.tsx
import { useMemo } from "react";
import { AnimatePresence as AnimatePresence2, motion as motion2 } from "motion/react";
import { Button as Button7, Spinner, Typography } from "@wbk/ui";
import { CloseIcon, DiscountCircleIcon, QitafIcon as QitafIcon3, SaudiRewardsIcon, WalletIcon } from "@wbk/svg";
import { twMerge } from "tailwind-merge";
import { useTranslation as useTranslation7 } from "@wbk/config";
import { CurrencyPriceLabel as CurrencyPriceLabel3, CurrencySymbol, useCurrency } from "@wbk/currency";

// src/components/booking/saudiRewards/SaudiRewards.tsx
import { Controller as Controller2, useForm as useForm2 } from "react-hook-form";
import { AnimatePresence, motion } from "motion/react";
import { Button as Button2, Input as Input2 } from "@wbk/ui";
import { formatPrice } from "@wbk/utils";
import { CurrencyPriceLabel } from "@wbk/currency";
import { useTranslation as useTranslation2 } from "@wbk/config";

// src/components/booking/saudiRewards/SaudiRewardsMemberForm.tsx
import { Controller, useForm } from "react-hook-form";
import { Button, ImageWithPlaceholder, Input } from "@wbk/ui";
import { useVerifySaudiRewards } from "@wbk/api/hooks";
import { useRouter, useTranslation } from "@wbk/config";
import { jsx, jsxs } from "react/jsx-runtime";
var SaudiRewardsMemberForm = () => {
  const { setSaudiRedeem } = useRedeem();
  const { mutateAsync, isPending, error } = useVerifySaudiRewards();
  const { event } = usePayment();
  const { locale } = useRouter();
  const { t } = useTranslation(["payment_common"]);
  const {
    handleSubmit,
    control,
    formState: { isValid }
  } = useForm({
    defaultValues: {
      memberId: "",
      memberPin: ""
    }
  });
  const handleVerify = (values) => __async(void 0, null, function* () {
    try {
      const data = yield mutateAsync(__spreadProps(__spreadValues({}, values), {
        lang: locale
      }));
      setSaudiRedeem(__spreadProps(__spreadValues({}, data), {
        quantity: 0
      }));
    } catch (err) {
    }
  });
  return /* @__PURE__ */ jsxs("form", { onSubmit: handleSubmit(handleVerify), className: "space-y-2", children: [
    /* @__PURE__ */ jsxs("div", { className: "mb-4 flex items-center justify-between gap-2 rounded-[4px] bg-violet-950 p-2 text-sm text-violet-300", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-2", children: [
        /* @__PURE__ */ jsx("span", { className: "text-lg", children: "\u2728" }),
        /* @__PURE__ */ jsx("p", { children: t("payment_common:link_saudi_rewards_account") })
      ] }),
      /* @__PURE__ */ jsx(
        ImageWithPlaceholder,
        {
          width: 75,
          height: 35,
          src: `/@wbk/payment/saudi_rewards_${locale === "ar" ? "ar" : "en"}.png`
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      Controller,
      {
        control,
        name: "memberId",
        rules: {
          required: t("payment_common:member_id_required")
        },
        render: ({ field, fieldState: { error: error2 } }) => {
          return /* @__PURE__ */ jsx(
            Input,
            __spreadProps(__spreadValues({}, field), {
              label: /* @__PURE__ */ jsx("span", { className: "text-sm", children: t("payment_common:enter_member_id") }),
              className: "w-full",
              placeholder: t("payment_common:member_id"),
              error: error2 == null ? void 0 : error2.message
            })
          );
        }
      }
    ),
    /* @__PURE__ */ jsx(
      Controller,
      {
        control,
        name: "memberPin",
        rules: {
          required: t("payment_common:security_pin_required")
        },
        render: ({ field, fieldState: { error: error2 } }) => {
          return /* @__PURE__ */ jsx(
            Input,
            __spreadProps(__spreadValues({}, field), {
              type: "password",
              label: /* @__PURE__ */ jsx("span", { className: "text-sm", children: t("payment_common:enter_pin") }),
              className: "w-full",
              placeholder: t("payment_common:security_pin"),
              error: error2 == null ? void 0 : error2.message
            })
          );
        }
      }
    ),
    (error == null ? void 0 : error.message) && /* @__PURE__ */ jsx("p", { className: "text-error py-2 text-sm", children: error.message }),
    /* @__PURE__ */ jsx(
      Button,
      {
        className: "ring-offset-body-level-2 mx-1 h-8 px-6 text-sm font-bold",
        theme: "primary",
        shape: "solid",
        type: "submit",
        id: "verify-saudi-reward-member",
        "data-event-name": event == null ? void 0 : event.title,
        disabled: !isValid,
        loading: isPending,
        children: t("payment_common:verify")
      }
    )
  ] });
};
var SaudiRewardsMemberForm_default = SaudiRewardsMemberForm;

// src/components/booking/saudiRewards/SaudiRewards.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var SaudiRewards = ({ totals }) => {
  const { saudi_redeem } = useRedeem();
  const isVerified = !!saudi_redeem;
  return /* @__PURE__ */ jsx2(AnimatePresence, { mode: "wait", initial: false, children: !isVerified ? /* @__PURE__ */ jsx2(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, children: /* @__PURE__ */ jsx2(SaudiRewardsMemberForm_default, {}) }) : /* @__PURE__ */ jsx2(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, children: /* @__PURE__ */ jsx2(RedeemPointsForm, { totals }) }) });
};
var RedeemPointsForm = ({ totals }) => {
  const { currency } = usePayment();
  const { t } = useTranslation2(["payment_common"]);
  const { saudi_redeem, saudi_redeem_total, setSaudiRedeem, walletData } = useRedeem();
  const maxPoints = convertCurrencyToPoints(
    totals.net_after_discount,
    (saudi_redeem == null ? void 0 : saudi_redeem.productConversion) || [],
    walletData == null ? void 0 : walletData.currency
  );
  const maximumPointsToRedeem = Math.min((saudi_redeem == null ? void 0 : saudi_redeem.productBalance) || 0, maxPoints);
  const { control, setValue, handleSubmit, watch } = useForm2({
    defaultValues: {
      points: maximumPointsToRedeem || 0
    }
  });
  const points = watch("points");
  const notMaxPoints = points !== maximumPointsToRedeem;
  if (!saudi_redeem)
    return null;
  const isRedeemed = saudi_redeem.quantity > 0;
  const hasNoBalance = saudi_redeem.productBalance <= 0;
  const setMaxPoints = () => {
    setValue("points", maximumPointsToRedeem);
  };
  const changeMember = () => {
    setSaudiRedeem(null);
  };
  const changePoints = () => {
    setSaudiRedeem(__spreadProps(__spreadValues({}, saudi_redeem), { quantity: 0 }));
  };
  const onSubmit = (values) => {
    setSaudiRedeem(__spreadProps(__spreadValues({}, saudi_redeem), {
      quantity: Math.min(values.points, maxPoints)
    }));
  };
  return /* @__PURE__ */ jsxs2("div", { className: "space-y-1", children: [
    /* @__PURE__ */ jsxs2("div", { className: "bg-body/20 mb-3 flex items-center gap-4 rounded-xl border border-white/10 px-3 py-2", children: [
      /* @__PURE__ */ jsxs2("div", { className: "flex flex-col gap-1 text-[13px]", children: [
        /* @__PURE__ */ jsxs2("span", { children: [
          t("payment_common:member_id"),
          ":"
        ] }),
        /* @__PURE__ */ jsxs2("div", { className: "flex items-center", children: [
          /* @__PURE__ */ jsx2("span", { children: saudi_redeem.memberId }),
          /* @__PURE__ */ jsx2(Button2, { shape: "text", theme: "primary", className: "mx-1 p-0", onClick: changeMember, children: t("payment_common:change") })
        ] })
      ] }),
      /* @__PURE__ */ jsx2("div", { className: "bg-body-dark/10 h-9 w-px" }),
      /* @__PURE__ */ jsxs2("div", { className: "flex flex-col gap-1 text-[13px]", children: [
        /* @__PURE__ */ jsxs2("span", { children: [
          t("payment_common:balance"),
          ":"
        ] }),
        /* @__PURE__ */ jsxs2("div", { children: [
          formatPrice(saudi_redeem.productBalance),
          " ",
          t("payment_common:pt"),
          " \u2248",
          " ",
          /* @__PURE__ */ jsx2(
            CurrencyPriceLabel,
            {
              originalPrice: convertPointsToCurrency(
                saudi_redeem.productBalance,
                saudi_redeem.productConversion,
                walletData == null ? void 0 : walletData.currency
              ),
              currency,
              className: "inline-flex"
            }
          )
        ] })
      ] })
    ] }),
    hasNoBalance ? /* @__PURE__ */ jsx2("p", { className: "text-error text-center text-sm", children: t("payment_common:not_enough_points") }) : !isRedeemed ? /* @__PURE__ */ jsx2("form", { onSubmit: handleSubmit(onSubmit), className: "mt-3", children: /* @__PURE__ */ jsx2("div", { className: "group relative w-full", children: /* @__PURE__ */ jsx2(
      Controller2,
      {
        control,
        name: "points",
        rules: {
          required: t("payment_common:validation.required"),
          validate: {
            max: (value) => {
              return value <= saudi_redeem.productBalance ? true : t("payment_common:redeem_points_error");
            }
          }
        },
        render: ({ field, fieldState: { error } }) => {
          return /* @__PURE__ */ jsxs2("div", { children: [
            /* @__PURE__ */ jsxs2("div", { className: "relative [&>label]:text-sm [&>label]:font-normal", children: [
              /* @__PURE__ */ jsx2(
                Input2,
                __spreadProps(__spreadValues({
                  type: "number",
                  label: t("payment_common:redeem_label"),
                  className: "w-full py-[12px]",
                  placeholder: t("payment_common:redeem_placeholder"),
                  error: error == null ? void 0 : error.message,
                  hideErrorSpace: true,
                  hideErrorMark: true
                }, field), {
                  value: field.value || ""
                })
              ),
              /* @__PURE__ */ jsxs2("div", { className: "absolute top-7 mx-2 flex h-[50px] items-center gap-2.5 ltr:right-0 rtl:left-0", children: [
                notMaxPoints && /* @__PURE__ */ jsx2(
                  "button",
                  {
                    type: "button",
                    className: "text-text-secondary text-sm",
                    onClick: setMaxPoints,
                    children: t("payment_common:max")
                  }
                ),
                /* @__PURE__ */ jsx2("div", { className: "bg-body-dark/10 h-8 w-px" }),
                /* @__PURE__ */ jsx2(
                  Button2,
                  {
                    className: "h-8 text-sm font-bold",
                    theme: "primary",
                    shape: "solid",
                    type: "submit",
                    id: "checkout-apply-coupon",
                    disabled: !points,
                    children: t("payment_common:redeem")
                  }
                )
              ] })
            ] }),
            field.value ? /* @__PURE__ */ jsxs2("div", { className: "text-text-secondary mt-2 flex items-center gap-1 text-[13px]", children: [
              /* @__PURE__ */ jsx2("span", { children: "=" }),
              /* @__PURE__ */ jsx2(
                CurrencyPriceLabel,
                {
                  originalPrice: convertPointsToCurrency(
                    field.value,
                    saudi_redeem.productConversion,
                    walletData == null ? void 0 : walletData.currency
                  ),
                  currency: walletData == null ? void 0 : walletData.currency
                }
              )
            ] }) : null
          ] });
        }
      }
    ) }) }) : /* @__PURE__ */ jsxs2("div", { className: "flex items-center gap-1 text-[13px]", children: [
      t("payment_common:redeemed_balance", { amount: saudi_redeem.quantity }),
      " =",
      /* @__PURE__ */ jsx2(CurrencyPriceLabel, { originalPrice: saudi_redeem_total, currency: walletData == null ? void 0 : walletData.currency }),
      /* @__PURE__ */ jsx2(Button2, { shape: "text", theme: "primary", className: "mx-1 px-2 py-1", onClick: changePoints, children: t("payment_common:change") })
    ] })
  ] });
};

// src/components/booking/qitaf/QitafForm.tsx
import { Button as Button5 } from "@wbk/ui";
import { QitafIcon as QitafIcon2 } from "@wbk/svg";
import { CurrencyPriceLabel as CurrencyPriceLabel2 } from "@wbk/currency";
import { useTranslation as useTranslation5 } from "@wbk/config";

// src/components/booking/qitaf/QitafPhone.tsx
import { Controller as Controller3, useForm as useForm3 } from "react-hook-form";
import { Button as Button3, Input as Input3 } from "@wbk/ui";
import { useSendQitafOtp } from "@wbk/api/hooks";
import { QitafIcon } from "@wbk/svg";
import { useAuth } from "@wbk/auth";
import { useRouter as useRouter2, useTranslation as useTranslation3 } from "@wbk/config";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var QitafPhone = () => {
  const { locale } = useRouter2();
  const { user } = useAuth();
  const { t } = useTranslation3(["payment_common"]);
  const { setQitaf } = useRedeem();
  const {
    control,
    handleSubmit,
    setError,
    formState: { isDirty }
  } = useForm3({
    defaultValues: { phone: "" }
  });
  const { mutateAsync, isPending } = useSendQitafOtp();
  const onSubmit = (data) => __async(void 0, null, function* () {
    var _a;
    try {
      const phone = ((_a = data.phone) == null ? void 0 : _a.startsWith("0")) ? data.phone.slice(1) : data.phone;
      yield mutateAsync({ phone, lang: locale, email: user.email });
      setQitaf({ phone: data.phone });
    } catch (err) {
      setError("phone", { message: err == null ? void 0 : err.message });
    }
  });
  return /* @__PURE__ */ jsxs3("form", { onSubmit: handleSubmit(onSubmit), className: "space-y-4", children: [
    /* @__PURE__ */ jsx3(
      Controller3,
      {
        control,
        name: "phone",
        rules: {
          required: t("payment_common:validation.required")
        },
        render: ({ field, fieldState: { error } }) => {
          return /* @__PURE__ */ jsxs3("div", { className: "space-y-2 [&_label]:text-sm", children: [
            /* @__PURE__ */ jsxs3("div", { className: "flex items-center justify-between", children: [
              /* @__PURE__ */ jsx3("label", { htmlFor: "qitafPhone", children: t("payment_common:enter_qitaf_phone") }),
              /* @__PURE__ */ jsx3(QitafIcon, { className: "h-8 w-8 shrink-0" })
            ] }),
            /* @__PURE__ */ jsxs3("div", { className: "flex items-start", dir: "ltr", children: [
              /* @__PURE__ */ jsxs3(
                "div",
                {
                  className: "bg-input border-input-border text-text-secondary flex h-10 shrink-0 items-center justify-between gap-2 rounded-md rounded-r-none border border-r-0 p-2",
                  dir: "ltr",
                  children: [
                    /* @__PURE__ */ jsx3(
                      "img",
                      {
                        className: "shrink-0",
                        src: "https://wbk-assets.s3.me-south-1.amazonaws.com/flags/w80/sa.png",
                        height: 14,
                        width: 20,
                        alt: "Saudi Arabia"
                      }
                    ),
                    /* @__PURE__ */ jsx3("div", { dir: "ltr", className: "font-sans", children: "+966" })
                  ]
                }
              ),
              /* @__PURE__ */ jsx3(
                Input3,
                __spreadProps(__spreadValues({}, field), {
                  minLength: 9,
                  maxLength: 10,
                  type: "tel",
                  error: error == null ? void 0 : error.message,
                  groupClassName: "grow",
                  className: "h-10 rounded-l-none font-sans",
                  dir: "ltr",
                  id: "qitafPhone"
                })
              )
            ] })
          ] });
        }
      }
    ),
    /* @__PURE__ */ jsx3(
      Button3,
      {
        type: "submit",
        className: "h-11 w-full capitalize",
        disabled: !isDirty,
        loading: isPending,
        children: t("payment_common:auth.verify")
      }
    )
  ] });
};
var QitafPhone_default = QitafPhone;

// src/components/booking/qitaf/QitafOtp.tsx
import { useState } from "react";
import { Button as Button4, Input as Input4, OtpInputs } from "@wbk/ui";
import { useRedeemQitaf, useSendQitafOtp as useSendQitafOtp2 } from "@wbk/api/hooks";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth as useAuth2 } from "@wbk/auth";
import { useRouter as useRouter3, useTranslation as useTranslation4 } from "@wbk/config";

// src/components/common/WithCountDown.tsx
import { useCountDown } from "@wbk/hooks";
var WithCountDown = ({ render, seconds }) => {
  const { count, reset, set } = useCountDown({ id: "withcount-down", initialSeconds: seconds });
  return render({ count, reset, set });
};

// src/components/booking/qitaf/QitafOtp.tsx
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var QitafOtp = ({ totals }) => {
  const { locale } = useRouter3();
  const { user } = useAuth2();
  const { t } = useTranslation4(["payment_common"]);
  const [data, setData] = useState({
    otp: "",
    amount: Math.ceil(totals.net_after_discount)
  });
  const { qitaf, setQitaf, setRedeemType } = useRedeem();
  const { mutateAsync, error, isPending, reset } = useRedeemQitaf();
  const queryClient = useQueryClient();
  if (!qitaf)
    return null;
  const handleSubmit = () => __async(void 0, null, function* () {
    try {
      yield mutateAsync({
        otp: Number(data.otp),
        amount: data.amount,
        phone: Number(qitaf.phone),
        email: user.email
      });
      setQitaf(__spreadValues(__spreadValues({}, qitaf), data));
      queryClient.setQueryData(
        ["getWalletHistory", { lang: locale, userId: user == null ? void 0 : user._id }],
        (oldWalletData) => {
          if (oldWalletData) {
            return __spreadProps(__spreadValues({}, oldWalletData), {
              total_balance: (oldWalletData == null ? void 0 : oldWalletData.total_balance) + data.amount
            });
          }
          return oldWalletData;
        }
      );
      setRedeemType("wallet");
    } catch (error2) {
    }
  });
  return /* @__PURE__ */ jsxs4("div", { className: "space-y-6", children: [
    /* @__PURE__ */ jsx4(
      OtpInputs,
      {
        onChange: (otp) => setData(__spreadProps(__spreadValues({}, data), { otp })),
        shape: "contained",
        legend: /* @__PURE__ */ jsx4("p", { className: "mb-1 text-sm", children: t("payment_common:enter_qitaf_otp") }),
        onlyNumbers: true,
        renderButton: ({ resetState }) => /* @__PURE__ */ jsx4("div", { className: "-mt-2 flex w-full justify-end", children: /* @__PURE__ */ jsx4(
          ResendOtp,
          {
            resetState: () => {
              resetState();
              reset();
            },
            phone: qitaf.phone
          }
        ) }),
        error: error == null ? void 0 : error.message
      }
    ),
    /* @__PURE__ */ jsxs4("div", { className: "relative [&_label]:text-sm", children: [
      /* @__PURE__ */ jsx4(
        Input4,
        {
          type: "number",
          label: t("payment_common:enter_qitaf_amount"),
          value: data.amount || "",
          onChange: (value) => setData(__spreadProps(__spreadValues({}, data), { amount: Math.ceil(Number(value)) })),
          max: totals.net_after_discount,
          min: 1,
          className: "[appearance:textfield] ltr:pr-10 rtl:pl-10 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
        }
      ),
      /* @__PURE__ */ jsx4("span", { className: "text-text-secondary absolute top-6 flex h-10 items-center justify-center ltr:right-2 rtl:left-2", children: "SAR" }),
      /* @__PURE__ */ jsx4("p", { className: "text-text-secondary mt-1 text-xs", children: t("payment_common:amount_as_whole_number") })
    ] }),
    /* @__PURE__ */ jsx4(
      Button4,
      {
        disabled: data.otp.length < 4 || data.amount > Math.ceil(totals.net_after_discount) || !data.amount,
        onClick: handleSubmit,
        loading: isPending,
        className: "h-11 w-full",
        children: t("payment_common:redeem_to_wallet")
      }
    )
  ] });
};
var ResendOtp = ({ phone, resetState }) => {
  const { locale } = useRouter3();
  const { t } = useTranslation4(["payment_common"]);
  const { mutateAsync, isPending } = useSendQitafOtp2();
  const { user } = useAuth2();
  const handleResend = () => __async(void 0, null, function* () {
    yield mutateAsync({ phone, lang: locale, email: user.email });
  });
  return /* @__PURE__ */ jsx4(
    WithCountDown,
    {
      seconds: 60,
      render: ({ count, reset }) => /* @__PURE__ */ jsxs4("div", { className: "mt-4 flex items-center justify-center gap-2", children: [
        /* @__PURE__ */ jsx4("p", { className: "text-text-secondary mx-1 text-sm", children: t("payment_common:auth.didnt_receive_it") }),
        /* @__PURE__ */ jsx4(
          Button4,
          {
            type: "button",
            shape: "text",
            className: "px-2 py-1 text-sm",
            disabled: count > 0,
            loading: isPending,
            onClick: () => __async(void 0, null, function* () {
              try {
                yield handleResend();
                reset();
                resetState();
              } catch (err) {
              }
            }),
            id: "resend-qitaf-otp",
            children: `${t("payment_common:auth.resend_otp")} ${count > 0 ? `(${count})` : ""}`
          }
        )
      ] })
    }
  );
};
var QitafOtp_default = QitafOtp;

// src/components/booking/qitaf/QitafForm.tsx
import { Fragment, jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var QitafForm = ({ totals }) => {
  const { t } = useTranslation5(["payment_common"]);
  const { qitaf, setQitaf } = useRedeem();
  const status = !qitaf ? "phone" : qitaf.otp ? "success" : "otp";
  return /* @__PURE__ */ jsxs5("div", { className: "border-paper space-y-3 rounded-xl border p-4", children: [
    !!qitaf && /* @__PURE__ */ jsxs5(Fragment, { children: [
      /* @__PURE__ */ jsxs5("div", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsxs5("div", { children: [
          /* @__PURE__ */ jsx5("p", { className: "text-text-secondary mb-1 text-xs", children: t("payment_common:auth.mobile") }),
          /* @__PURE__ */ jsxs5("p", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx5("span", { dir: "ltr", children: "+966" + qitaf.phone }),
            status !== "phone" && /* @__PURE__ */ jsx5(Button5, { shape: "text", onClick: () => setQitaf(null), className: "p-1 text-xs", children: t("payment_common:change") })
          ] })
        ] }),
        status !== "success" && /* @__PURE__ */ jsx5(QitafIcon2, { className: "h-8 w-8 shrink-0" })
      ] }),
      status === "success" && (qitaf == null ? void 0 : qitaf.amount) && /* @__PURE__ */ jsxs5("div", { className: "relative z-10 flex items-center gap-4 border-t border-white/20 pt-2", children: [
        /* @__PURE__ */ jsx5(
          "img",
          {
            src: "/@wbk/payment/firework_mini_once.gif",
            className: "absolute top-0 -z-[1] h-32 w-32 -translate-y-1/3 ltr:left-0 ltr:-translate-x-1/4 rtl:right-0 rtl:translate-x-1/4",
            alt: ""
          }
        ),
        /* @__PURE__ */ jsxs5("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx5(
            CurrencyPriceLabel2,
            {
              className: "text-success-light text-lg font-black",
              originalPrice: qitaf.amount,
              currency: "SAR"
            }
          ),
          /* @__PURE__ */ jsx5("p", { className: "text-text-secondary text-xs", children: t("payment_common:redeemed_amount_in_wallet") })
        ] }),
        /* @__PURE__ */ jsx5(QitafIcon2, { className: "relative z-10 h-10 w-10 shrink-0" })
      ] })
    ] }),
    status === "phone" && /* @__PURE__ */ jsx5(QitafPhone_default, {}),
    status === "otp" && /* @__PURE__ */ jsx5(QitafOtp_default, { totals })
  ] });
};
var QitafForm_default = QitafForm;

// src/components/booking/redeem/Coupon.tsx
import { useState as useState2 } from "react";
import { Button as Button6, Input as Input5 } from "@wbk/ui";
import { useVerifyCoupon } from "@wbk/api/hooks";
import { useRouter as useRouter4, useTranslation as useTranslation6 } from "@wbk/config";
import { jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
var CouponForm = ({ isAppliedToAll }) => {
  var _a, _b;
  const { event, isSeason } = usePayment();
  const { coupon, setCoupon, selected_ticket_ids } = useRedeem();
  const [promoCode, setPromoCode] = useState2(coupon.promo_code);
  const { mutateAsync, isPending, error } = useVerifyCoupon();
  const { locale } = useRouter4();
  const { t } = useTranslation6(["payment_common"]);
  const handleSubmit = () => __async(void 0, null, function* () {
    if (!promoCode)
      return;
    try {
      const data = yield mutateAsync(__spreadProps(__spreadValues({}, isSeason ? { season_id: event == null ? void 0 : event._id } : { event_id: event == null ? void 0 : event._id }), {
        promo_code: promoCode,
        ticket_ids: selected_ticket_ids,
        locale
      }));
      setCoupon(__spreadProps(__spreadValues({}, data), {
        promo_code: promoCode
      }));
    } catch (error2) {
    }
  });
  const removePromo = () => {
    setCoupon({
      discount: 0,
      promo_code: "",
      ticket_ids: []
    });
  };
  return /* @__PURE__ */ jsxs6("div", { children: [
    /* @__PURE__ */ jsx6(
      "form",
      {
        onSubmit: (e) => {
          e.preventDefault();
          handleSubmit();
        },
        children: /* @__PURE__ */ jsxs6("div", { className: "group relative w-full", children: [
          /* @__PURE__ */ jsx6(
            Input5,
            {
              defaultValue: coupon.promo_code,
              "data-testid": "ticketing_summary_coupon_input",
              label: /* @__PURE__ */ jsx6("span", { className: "text-sm", children: t("payment_common:enter_coupon") }),
              disabled: !!coupon.promo_code || isPending,
              className: ((_a = coupon.ticket_ids) == null ? void 0 : _a.length) > 0 ? "text-success-light" : "",
              placeholder: t("payment_common:enter_coupon"),
              error: error == null ? void 0 : error.message,
              hideErrorSpace: true,
              hideErrorMark: true,
              onChange: (value) => {
                setPromoCode(value);
              }
            }
          ),
          /* @__PURE__ */ jsx6("div", { className: "absolute top-6 mx-2 flex h-[50px] items-center ltr:right-0 rtl:left-0", children: /* @__PURE__ */ jsx6(
            Button6,
            {
              className: `h-8 text-sm font-bold ${coupon.promo_code ? "bg-body-dark/10" : ""}`,
              theme: coupon.promo_code ? "white" : "primary",
              shape: coupon.promo_code ? "text" : "solid",
              type: coupon.promo_code ? "button" : "submit",
              onClick: (e) => {
                if (coupon.promo_code) {
                  e.preventDefault();
                  removePromo();
                }
              },
              id: "checkout-apply-coupon",
              "data-testid": "ticketing_summary_coupon_add_button",
              "data-event-name": event == null ? void 0 : event.title,
              "data-promo": coupon.promo_code,
              disabled: !(promoCode == null ? void 0 : promoCode.trim()),
              loading: isPending,
              children: coupon.promo_code ? t("payment_common:remove") : t("payment_common:apply")
            }
          ) })
        ] })
      }
    ),
    ((_b = coupon.ticket_ids) == null ? void 0 : _b.length) > 0 ? /* @__PURE__ */ jsx6("div", { className: "pt-1.5 text-sm text-green-500", children: isAppliedToAll ? t("payment_common:coupon_all") : t("payment_common:coupon_some") }) : null
  ] });
};

// src/components/booking/redeem/RedeemForm.tsx
import { jsx as jsx7, jsxs as jsxs7 } from "react/jsx-runtime";
var REDEEM_OPTIONS = [
  {
    Icon: WalletIcon,
    label: "wallet_credit",
    value: "wallet"
  },
  {
    Icon: DiscountCircleIcon,
    label: "promo_code",
    value: "coupon"
  },
  {
    Icon: SaudiRewardsIcon,
    label: "saudi_rewards",
    value: "saudi_rewards"
  },
  {
    Icon: QitafIcon3,
    label: "qitaf",
    value: "qitaf"
  }
];
var RedeemForm = ({ className, totals, isCouponAppliedToAll, hideWallet }) => {
  const {
    isWalletEnabled,
    isQitafEnabled,
    isSaudiRewardsEnabled,
    components,
    isSubscriptionCreditsEnabled,
    isSeason
  } = usePayment();
  const { t } = useTranslation7("payment_common");
  const { unExchangePrice, currency: displayCurrency, currencies } = useCurrency();
  const { walletData, redeem_type, setRedeemType } = useRedeem();
  const balance = (walletData == null ? void 0 : walletData.total_balance) || 0;
  const isSAR = displayCurrency.shortCode === "SAR";
  const walletEnabled = isWalletEnabled && balance > 0 && isSAR && !isSeason && !hideWallet;
  const redeemOptions = useMemo(() => {
    return REDEEM_OPTIONS.filter(
      (op) => op.value === "coupon" || op.value === "wallet" && walletEnabled || op.value === "qitaf" && isQitafEnabled || op.value === "saudi_rewards" && isSaudiRewardsEnabled
    );
  }, [isQitafEnabled, isSaudiRewardsEnabled, walletEnabled]);
  const SarCurrency = useMemo(() => {
    return currencies.find((currency) => currency.shortCode === "SAR");
  }, [currencies]);
  if (isSubscriptionCreditsEnabled) {
    return null;
  }
  return /* @__PURE__ */ jsxs7("div", { className: twMerge("space-y-4", className), children: [
    /* @__PURE__ */ jsx7(Typography, { variant: "heading-M", children: t("payment_common:redeem_title") }),
    /* @__PURE__ */ jsx7("div", { className: "flex flex-wrap items-center gap-2", children: redeemOptions.map((option) => {
      const isSelected = option.value === redeem_type;
      const Icon = option.Icon;
      return /* @__PURE__ */ jsxs7(
        Button7,
        {
          className: "border-paper aria-pressed:border-action shrink-0 px-3 py-1",
          shape: "outlined",
          theme: "action",
          phill: true,
          "data-testid": `ticketing_summary_redeem_${option.value}`,
          "aria-pressed": isSelected,
          onClick: () => {
            if (isSelected) {
              return setRedeemType(void 0);
            }
            setRedeemType(option.value);
          },
          disabled: option.value === "wallet" && balance <= 0,
          children: [
            /* @__PURE__ */ jsx7(
              Icon,
              {
                "data-qitaf": option.value === "qitaf",
                className: "h-5 w-5 shrink-0 [&>rect]:data-[qitaf=true]:fill-transparent"
              }
            ),
            /* @__PURE__ */ jsx7(Typography, { variant: "label-M", color: isSelected ? "text-primary" : "text-secondary", children: t(`payment_common:${option.label}`) }),
            option.value === "wallet" && /* @__PURE__ */ jsxs7(Typography, { as: "div", className: "inline-flex", color: "text-secondary", children: [
              "(",
              /* @__PURE__ */ jsx7(CurrencyPriceLabel3, { originalPrice: balance, currency: "SAR" }),
              displayCurrency.shortCode !== "SAR" ? /* @__PURE__ */ jsxs7("span", { className: "inline-flex items-center", children: [
                " \u2248 ",
                /* @__PURE__ */ jsx7(CurrencySymbol, { currency: SarCurrency }),
                unExchangePrice(balance, "SAR")
              ] }) : null,
              ")"
            ] }),
            isSelected && /* @__PURE__ */ jsx7(CloseIcon, { className: "mt-px h-3 w-3" }),
            (walletData == null ? void 0 : walletData.loading) && option.value === "wallet" && /* @__PURE__ */ jsx7(Spinner, { className: "h-4 w-4 shrink-0" })
          ]
        },
        option.value
      );
    }) }),
    /* @__PURE__ */ jsx7(AnimatePresence2, { initial: false, mode: "wait", children: /* @__PURE__ */ jsx7(
      motion2.div,
      {
        className: "max-w-lg overflow-hidden",
        initial: { height: 0 },
        animate: { height: redeem_type === "wallet" ? 0 : "auto" },
        exit: { height: 0 },
        children: !!redeem_type && /* @__PURE__ */ jsx7("div", { className: "pb-2 pt-4", children: redeem_type === "wallet" ? null : redeem_type === "saudi_rewards" ? /* @__PURE__ */ jsx7(SaudiRewards, { totals }) : redeem_type === "qitaf" ? /* @__PURE__ */ jsx7(QitafForm_default, { totals }) : (components == null ? void 0 : components.CouponForm) ? /* @__PURE__ */ jsx7(components.CouponForm, {}) : /* @__PURE__ */ jsx7(CouponForm, { isAppliedToAll: isCouponAppliedToAll }) })
      },
      redeem_type
    ) })
  ] });
};
var RedeemForm_default = RedeemForm;

export {
  RedeemForm_default
};
//# sourceMappingURL=chunk-WPZX6PL3.mjs.map